function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ageRestrictions } from 'shared/constants';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
// Match the order validator's oldest accepted customer age so persisted settings cannot create an impossible boundary.
var MAXIMUM_AGE_OVERRIDE = 120;
var validAgeOverride = function(value) {
    return Number.isInteger(value) && value > 0 && value <= MAXIMUM_AGE_OVERRIDE;
};
var getEffectiveMinimumAges = function(overrides, medDutchieMinimum, recDutchieMinimum) {
    var _overrides_medical;
    var medMinAge = Math.max((_overrides_medical = overrides.medical) !== null && _overrides_medical !== void 0 ? _overrides_medical : medDutchieMinimum, medDutchieMinimum);
    var _overrides_rec;
    var recMinAge = Math.max((_overrides_rec = overrides.rec) !== null && _overrides_rec !== void 0 ? _overrides_rec : recDutchieMinimum, recDutchieMinimum, medMinAge);
    return {
        medMinAge: medMinAge,
        recMinAge: recMinAge
    };
};
var getCustomerAgeOverrides = function(dispensary, configurablePurchaseLimitsFeatureEnabled) {
    var _dispensary_storeSettings, _dispensary_location;
    if (!configurablePurchaseLimitsFeatureEnabled || !(dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_storeSettings = dispensary.storeSettings) === null || _dispensary_storeSettings === void 0 ? void 0 : _dispensary_storeSettings.configurablePurchaseLimitsEnabled)) {
        return {};
    }
    var configuration = dispensary.storeSettings.customPurchaseLimits;
    if (!configuration || configuration.state !== ((_dispensary_location = dispensary.location) === null || _dispensary_location === void 0 ? void 0 : _dispensary_location.state)) return {};
    var _configuration_ageOverrides;
    var overrides = (_configuration_ageOverrides = configuration.ageOverrides) !== null && _configuration_ageOverrides !== void 0 ? _configuration_ageOverrides : {};
    return _object_spread({}, validAgeOverride(overrides.medical) ? {
        medical: overrides.medical
    } : {}, validAgeOverride(overrides.rec) ? {
        rec: overrides.rec
    } : {});
};
/**
 * Returns age restriction configuration for a given geo location.
 * @param {Object} geoInfo - Object containing country and region
 * @param {Object} options - Optional dispensary and rollout context
 * @returns {Object} Object with medMinAge, recMinAge, requiresBirthdayEntry, and forceSessionStorage
 */ export function getAgeRestriction(geoInfo) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _ageRestrictions_country;
    var _ref = geoInfo || {}, country = _ref.country, region = _ref.region;
    var dispensary = options.dispensary, _options_configurablePurchaseLimitsFeatureEnabled = options.configurablePurchaseLimitsFeatureEnabled, configurablePurchaseLimitsFeatureEnabled = _options_configurablePurchaseLimitsFeatureEnabled === void 0 ? false : _options_configurablePurchaseLimitsFeatureEnabled;
    var ageOverrides = getCustomerAgeOverrides(dispensary, configurablePurchaseLimitsFeatureEnabled);
    // For Canada, use the existing age restrictions constants
    // Canada already has birthday entry via the territory picker modal
    if (country === 'CA') {
        var provinceAge = ageRestrictions.CA[region] || ageRestrictions.CA.default;
        return _object_spread_props(_object_spread({}, getEffectiveMinimumAges(ageOverrides, provinceAge, provinceAge)), {
            requiresBirthdayEntry: true,
            forceSessionStorage: false
        });
    }
    // For US states, use compliance config which has detailed state-specific rules
    if (country === 'US') {
        var medMinAge = getComplianceConfig(region, 'medMinAge');
        var recMinAge = getComplianceConfig(region, 'recMinAge');
        var requiresBirthdayEntry = getComplianceConfig(region, 'requiresBirthdayEntry') || false;
        var forceSessionStorage = getComplianceConfig(region, 'forceSessionStorage') || false;
        return _object_spread_props(_object_spread({}, getEffectiveMinimumAges(ageOverrides, medMinAge, recMinAge)), {
            requiresBirthdayEntry: requiresBirthdayEntry,
            forceSessionStorage: forceSessionStorage
        });
    }
    // For other countries, use default age restriction
    var defaultAge = ((_ageRestrictions_country = ageRestrictions[country]) === null || _ageRestrictions_country === void 0 ? void 0 : _ageRestrictions_country.default) || ageRestrictions.default;
    return _object_spread_props(_object_spread({}, getEffectiveMinimumAges(ageOverrides, defaultAge, defaultAge)), {
        requiresBirthdayEntry: false,
        forceSessionStorage: false
    });
}
